import type { ShopProductsResponseDto } from "~/common/interfaces/dto/shop/shop-products-response.dto";
import type { PricePolicyTrimmed } from "~/common/interfaces/price-policy-trimmed";

export const getItemMinPrice = (
	pricePolicies: PricePolicyTrimmed[] = [],
	item: ShopProductsResponseDto
) => {
	pricePolicies.sort((a, b) => a.price - b.price);

	const policy = pricePolicies.find((policy) => {
		return (
			item.kind.id &&
			item.materialIds.some(materialId =>
				policy.materials.includes(materialId)
			) &&
			item.sizeIds.some(sizeId => policy.sizes.includes(sizeId))
		);
	});

	return policy && policy.price;
};
